import { useNavigate } from 'react-router-dom';

interface SuccessStepProps {
  role: 'patient' | 'caregiver';
}

export default function SuccessStep({ role }: SuccessStepProps) {
  const navigate = useNavigate();

  const roleTitle = role === 'patient' ? '환자 / 보호자' : '간병인';

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="w-20 h-20 rounded-full bg-[#E8F5E9] flex items-center justify-center mb-6">
        <i className="ri-checkbox-circle-line text-4xl text-[#2E7D6B]" />
      </div>
      <h2 className="text-xl font-bold text-gray-900 mb-2">
        회원가입이 완료되었습니다!
      </h2>
      <p className="text-sm text-gray-500 mb-2">
        {roleTitle}로 가입되었습니다.
      </p>
      <p className="text-xs text-gray-400 mb-8 leading-relaxed">
        메인 화면에서 {role === 'patient' ? '환자 상세정보 등록' : '간병인 상세정보 등록'}을 진행하면<br />
        매칭 서비스를 이용하실 수 있습니다.
      </p>

      <div className="w-full space-y-3">
        <button
          onClick={() => navigate('/app', { replace: true })}
          className="w-full py-3.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#2E7D6B' }}
        >
          메인 화면으로 가기
        </button>
      </div>
    </div>
  );
}